const GET_PROFILE = 'GET_PROFILE' as const;
const FOLLOW = 'FOLLOW' as const;
const UNFOLLOW = 'UNFOLLOW' as const;

const profileActionTypes = {
  GET_PROFILE,
  FOLLOW,
  UNFOLLOW,
};

export default profileActionTypes;
